<template>
  <div id="app tagset" class="pt-2">
    <div v-if="loading" class="loading"></div>

    <div class="columns" v-if="!loading">
      <div class="column col-sm-12 col-4" :class="{ 'hide-sm': selectedCategory.length }">
        <h3 class="show-sm">Categories</h3>

        <table class="tagset-table">
          <thead>
            <th>Tag Category</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <a @click.prevent.stop="showFreeforms" href="#"
                  :class="{ 'text-bold': selectedCategory == 'freeforms' }">
                  Freeforms
                </a>
              </td>
            </tr>

            <tr>
              <td>
                <div class="divider text-center" data-content="Categories"></div>
              </td>
            </tr>
            <tr>
              <td>
                <a @click.prevent.stop="showFandoms()" href="#" :class="{ 'text-bold': selectedCategory == 'fandoms' }">
                  All Fandoms In All Categories
                </a>
              </td>
            </tr>
            <tr v-for="category in categories" :key="category">
              <td>
                <a @click.prevent.stop="showFandoms(category)" href="#"
                  :class="{ 'text-bold': selectedCategory == category }">
                  {{ category }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- FREEFORMS -->
      <div v-if="selected == 'freeforms'" class="column col-sm-12 col-8">
        <h3 class="show-sm">Freeforms</h3>
        <a @click.stop.prevent="
          selectedCategory = '';
        selected = '';
        " href="#" class="show-sm">Select A Different Category</a>

        <div class="input-group">
          <span class="input-group-addon">Filter Freeforms</span>
          <input class="form-input" type="text" id="freeform-filter" placeholder="Search freeforms..."
            v-model="freeformFilter" />
        </div>
        <table class="tagset-table">
          <thead>
            <th>Freeform Tags</th>
          </thead>
          <tbody>
            <tr v-for="tag in filteredFreeforms" :key="tag.tag">
              <td>{{ tag.tag }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- FANDOMS -->
      <div v-if="selected == 'fandoms' || selected == 'characters'" class="column col-sm-12 col-4"
        :class="{ 'hide-sm': selectedFandom.length }">
        <h3 class="show-sm">Fandoms</h3>

        <a @click.stop.prevent="
          selectedCategory = '';
        selected = '';
        " href="#" class="show-sm">Select A Different Category</a>

        <div v-if="selectedFandoms.length" class="input-group">
          <span class="input-group-addon">Filter Fandoms</span>
          <input class="form-input" type="text" id="fandom-filter" placeholder="Search..." v-model="fandomFilter" />
        </div>
        <table class="tagset-table">
          <thead>
            <th>Fandoms</th>
          </thead>
          <tbody>
            <tr v-for="fandom in filteredFandoms" :key="fandom.name">
              <td>
                <a @click.prevent.stop="showChars(fandom.name)" href="#"
                  :class="{ 'text-bold': selectedFandom == fandom.name }">
                  {{ fandom.name }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- CHARACTERS -->
      <div v-if="selected == 'fandoms' || selected == 'characters'" class="column col-sm-12 col-4">
        <h3 class="show-sm">Characters</h3>

        <a @click.stop.prevent="
          selectedFandom = '';
        selectedData = [];
        " href="#" class="show-sm">Select A Different Fandom</a>
        <div v-if="loadingChar" class="loading"></div>

        <template v-else>
          <div v-if="selectedData.length" class="input-group">
            <span class="input-group-addon">Filter Characters</span>
            <input class="form-input" type="text" id="character-filter" placeholder="Search..."
              v-model="characterFilter" />
          </div>

          <table v-if="selectedData.length" class="tagset-table">
            <thead>
              <th>Characters</th>
            </thead>
            <tbody>
              <tr v-for="tag in filteredChars" :key="tag.tag">
                <td>{{ tag.tag }}</td>
              </tr>
            </tbody>
          </table>
          <div v-else-if="!selectedFandom" class="empty">
            <p class="empty-title h5">
              Select a fandom to see nominated sub-tags
            </p>
          </div>
          <div v-else>No sub-tags for this fandom</div>
        </template>
      </div>

      <div class="column col-sm-12 col-8">
        <div v-if="selectedCategory == '' && selectedFandom == ''" class="empty">
          <p class="empty-title h5">
            Select a category to see nominated sub-tags.
          </p>
          <p>
            You can also download tagsets
            <a href="https://autoao3app.fandom.tools/#/help?goto=sheets">as a CSV</a>.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { each, filter, includes, sortBy, uniq } from "lodash-es";

// Remove english articles from fandom names
function removeArticlesCompare(o) {
  if (!o) {
    return;
  }
  const regex = /^(the\s|a\s|an\s)/i;
  if (!o.name) {
    return o;
  }
  return o.name.toLowerCase().replace(regex, "");
}

export default {
  name: "tagset",
  data() {
    return {
      loading: false,
      loadingChar: false,
      categories: [],
      characters: {},
      fandoms: [],
      freeforms: [],
      selectedFandoms: [],
      selectedData: [],
      selected: "",
      selectedFandom: "",
      selectedCategory: "",
      freeformFilter: "",
      filteredFreeforms: [],
      characterFilter: "",
      filteredChars: [],
      fandomFilter: "",
      filteredFandoms: []
    };
  },
  beforeMount() {
    this.load();
  },
  computed: {
    ...mapGetters(["exchangeId"])
  },
  watch: {
    $route(to, from) {
      if (to.name != "tagset") return;

      if (
        to.name !== from.name ||
        this.exchangeId != this.$route.params.exchangeId
      ) {
        this.$store.commit("setExchangeId", this.$route.params.exchangeId);
        this.load();
      }
    },
    fandomFilter(val) {
      if (!val || !val.length) {
        this.filteredFandoms = this.selectedFandoms;
        return;
      }
      this.filteredFandoms = sortBy(
        filter(this.selectedFandoms, o => {
          const name = o.name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          return name.indexOf(this.fandomFilter.toLowerCase()) > -1;
        }),
        removeArticlesCompare
      );
    },
    freeformFilter(val) {
      if (!val || !val.length) {
        this.filteredFreeforms = this.freeforms;
        return;
      }
      this.filteredFreeforms = sortBy(
        filter(this.freeforms, o => {
          const name = o.tag
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          return name.indexOf(this.freeformFilter.toLowerCase()) > -1;
        }),
        removeArticlesCompare
      );
    },
    characterFilter(val) {
      if (!val || !val.length) {
        this.filteredChars = this.selectedData;
        return;
      }
      this.filteredChars = sortBy(
        filter(this.selectedData, o => {
          const name = o.tag
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          return name.indexOf(this.characterFilter.toLowerCase()) > -1;
        }),
        removeArticlesCompare
      );
    }
  },
  methods: {
    showFreeforms() {
      this.selected = "freeforms";
      this.selectedCategory = "freeforms";
      this.selectedData = sortBy(this.freeforms, removeArticlesCompare);
      this.filteredFreeforms = this.selectedData;
      this.selectedFandom = "";
    },
    showFandoms(category) {
      this.selected = "fandoms";

      if (!category) {
        this.selectedFandoms = this.fandoms;
      } else {
        this.selectedCategory = category;
        this.selectedFandoms = filter(this.fandoms, f => {
          return includes(f.categories, category);
        });
      }
      this.filteredFandoms = sortBy(
        this.selectedFandoms,
        removeArticlesCompare
      );

      this.selectedData = [];
      this.selectedFandom = "";
    },
    async showChars(fandom) {
      window.scrollTo(0, 0);
      this.selectedFandom = fandom;
      this.loadingChar = true;
      const url = `https://autoao3.herokuapp.com/db/exchange/${encodeURIComponent(
        this.exchangeId
      )}/${encodeURIComponent(fandom)}/characters`;

      const characters = await axios
        .get(url)
        .then(res => res.data)
        .catch(() => []);

      this.selected = "characters";
      this.selectedData = sortBy(characters, f => f.tag);
      this.filteredChars = this.selectedData;
      this.loadingChar = false;
    },
    async load() {
      this.$store.commit("setExchangeId", this.$route.params.exchangeId);

      if (!this.exchangeId || !this.exchangeId.length) return;

      this.selectedCategory = "";
      this.selected = "";
      this.selectedFandom = "";
      this.selectedData = [];
      this.selectedFandoms = [];
      this.loading = true;

      const fandomUrl = `https://autoao3.herokuapp.com/db/exchange/${encodeURIComponent(
        this.exchangeId
      )}/fandoms`;
      const freeformsUrl = `https://autoao3.herokuapp.com/db/exchange/${encodeURIComponent(
        this.exchangeId
      )}/freeforms`;

      const fandoms = await axios
        .get(fandomUrl)
        .then(res => res.data)
        .catch(() => []);

      this.fandoms = sortBy(fandoms, f => f.name);
      let categories = [];
      each(fandoms, o => {
        each(o.categories, cat => {
          if (!cat.length) {
            return;
          }
          categories.push(cat);
        });
      });

      categories = uniq(sortBy(categories, c => c));

      this.categories = categories;

      const freeforms = await axios
        .get(freeformsUrl)
        .then(res => res.data)
        .catch(() => []);

      this.freeforms = sortBy(freeforms, f => f.tag);

      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
// Tables
.tagset-table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;

  td,
  th {
    padding: 0.25rem;
    border-bottom: 1px solid #eee;
  }
}

.dark .tagset-table {

  th,
  td {
    border-bottom: 1px solid #9fb3b6;

  }
}
</style>
